'use client';

import { cn } from '@/lib/utils';

export interface CategoryTabItem {
  id: string;
  label: string;
  count: number;
}

interface CategoryTabsProps {
  items: CategoryTabItem[];
  activeId: string;
  onSelect: (id: string) => void;
  allLabel?: string;
  totalCount: number;
}

export function CategoryTabs({
  items,
  activeId,
  onSelect,
  allLabel = 'All',
  totalCount,
}: CategoryTabsProps) {
  return (
    <div
      role="tablist"
      className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-2 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0"
    >
      <TabButton
        active={activeId === 'all'}
        onClick={() => onSelect('all')}
        label={allLabel}
        count={totalCount}
      />
      {items.map((item) => (
        <TabButton
          key={item.id}
          active={activeId === item.id}
          onClick={() => onSelect(item.id)}
          label={item.label}
          count={item.count}
        />
      ))}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  label,
  count,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  count: number;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        'shrink-0 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors',
        active
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border bg-background text-muted-foreground hover:bg-muted hover:text-foreground',
      )}
    >
      {label} <span className="opacity-70">({count})</span>
    </button>
  );
}
